import React from 'react'
import style from "../../drama/[dramaSlug]/Drama.module.css";

type BaseQuality = "240p" | "480p" | "720p";
type Quality = "nosub240p" | "nosub480p" | "nosub720p" | BaseQuality;

function QualitySelector({ quality, handleQualityChange }: { quality: Quality, handleQualityChange: (quality: BaseQuality) => void }) {
    return (
        <div className={style.dropdownContainer}>
            <div className={style.logingroup}>
                {/* <input
                  type="checkbox"
                  id="logintoggle"
                  className={style.hiddenCheckbox}
                /> */}
                <label
                    htmlFor="logintoggle"
                    className={`${style.loginlabel} ${style.commonBtn}`}
                >
                    <span className={style.userIcon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="17" viewBox="0 0 28 17" fill="none">
                            <g style={{ mixBlendMode: "screen" }}>
                                <path d="M0.908203 2.20933V15.2012C0.908203 16.1631 1.68688 16.9418 2.64878 16.9418H19.1676C20.1295 16.9418 20.9082 16.1631 20.9082 15.2012V2.20933C20.9082 1.24743 20.1295 0.46875 19.1676 0.46875H2.64878C1.68688 0.46875 0.908203 1.24743 0.908203 2.20933ZM19.0885 14.9639H2.73621V2.44668H19.0885V14.9639Z"
                                    fill="#AFAFAF"
                                />
                            </g>
                            <path d="M10.613 6.00473C10.705 6.0967 10.7506 6.21567 10.7506 6.36165V11.0472C10.7506 11.1881 10.7016 11.3054 10.6046 11.3999C10.5076 11.4944 10.3827 11.5417 10.2316 11.5417C10.0966 11.5417 9.98019 11.4944 9.88315 11.3999C9.78611 11.3054 9.73717 11.1881 9.73717 11.0472V9.15797H7.15096V11.0472C7.15096 11.1881 7.09948 11.3054 6.99654 11.3999C6.8936 11.4944 6.77462 11.5417 6.63962 11.5417C6.49364 11.5417 6.37298 11.4944 6.27848 11.3999C6.18397 11.3054 6.13672 11.1881 6.13672 11.0472V6.36165C6.13672 6.22074 6.18566 6.10345 6.28269 6.00894C6.37973 5.91444 6.50461 5.86719 6.65565 5.86719C6.79066 5.86719 6.9071 5.91444 7.00414 6.00894C7.10117 6.10345 7.15011 6.22074 7.15011 6.36165V8.22643H9.73633V6.36165C9.73633 6.22074 9.7878 6.10345 9.89074 6.00894C9.99369 5.91444 10.1127 5.86719 10.2477 5.86719C10.3987 5.86719 10.5202 5.91275 10.6122 6.00473H10.613Z"
                                fill="#FF0000"
                            />
                            <path d="M15.7082 6.24352C16.0727 6.49497 16.3511 6.83502 16.5435 7.26535C16.7351 7.69484 16.8313 8.17496 16.8313 8.70401C16.8313 9.23307 16.7351 9.71319 16.5435 10.1427C16.352 10.5722 16.0735 10.9131 15.7082 11.1645C15.3428 11.416 14.9066 11.5417 14.3986 11.5417H12.4613C12.3203 11.5417 12.2031 11.4944 12.1086 11.3999C12.014 11.3054 11.9668 11.1881 11.9668 11.0472V6.36165C11.9668 6.22074 12.014 6.10345 12.1086 6.00894C12.2031 5.91444 12.3203 5.86719 12.4613 5.86719H14.3986C14.9066 5.86719 15.3428 5.99291 15.7082 6.24436V6.24352ZM15.412 10.071C15.655 9.7115 15.7765 9.25585 15.7765 8.70486C15.7765 8.15386 15.6533 7.69821 15.4078 7.33876C15.1614 6.9793 14.7986 6.79958 14.3176 6.79958H12.9802V10.6101H14.3176C14.8036 10.6101 15.169 10.4304 15.412 10.071Z"
                                fill="#FF0000"
                            />
                            <path d="M20.9016 6.98996V10.5775L25.3938 12.4208V4.50446L20.9016 6.98996ZM27.2056 13.3758C27.2056 14.2037 26.4645 14.7888 25.728 14.5945L25.5809 14.5455L19.8496 12.1933C19.392 12.0056 19.09 11.5417 19.0898 11.0246V6.59679C19.0898 6.13055 19.3357 5.7028 19.7276 5.48591L25.459 2.3131L25.6098 2.24349C26.3682 1.95173 27.2053 2.53918 27.2056 3.42398V13.3758Z"
                                fill="#B8B7B9"
                            />
                        </svg>
                    </span>
                </label>
                <div className={`${style.dropdown}`}>
                    <div
                        onClick={() => handleQualityChange("240p")}
                        className={quality.includes("240p") ? style.active : ""}
                    >Low
                    </div>
                    <div
                        onClick={() => handleQualityChange("480p")}
                        className={quality.includes("480p") ? style.active : ""}
                    >Medium
                    </div>
                    <div
                        onClick={() => handleQualityChange("720p")}
                        className={quality.includes("720p") ? style.active : ""}
                    >High
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QualitySelector